const app = {
  state: {
    userId: sessionStorage.getItem("userInfo") || "",
    tpConfig: JSON.parse(sessionStorage.getItem("tpConfig")) || {},
    config: JSON.parse(sessionStorage.getItem("config")) || {},
    channelObj: null,
    isMac: false,
    sessionId: "",
  },
  mutations: {
    SetUserId: (state, data) => {
      state.userId = data;
    },
    SetTpConfig: (state, data) => {
      state.tpConfig = data;
      sessionStorage.setItem("tpConfig", JSON.stringify(data));
    },
    SetConfig: (state, data) => {
      state.config = data;
      sessionStorage.setItem("config", JSON.stringify(data));
    },
    SetChannelObj: (state, data) => {
      state.channelObj = data;
      // sessionStorage.setItem("channelObj", JSON.stringify(data));
    },
    SetIsMac: (state, data) => {
      state.isMac = data;
    },
    SetSessionId: (state, data) => {
      state.sessionId = data;
    },
  },
  actions: {
    // SetUserInfo({ commit }, token) {
    //   return new Promise((resolve, reject) => {
    //     getToken({ token }).then((res) => {
    //       if (res && res.code != 500) {
    //         commit("SET_USER_INFO", res);
    //         sessionStorage.setItem("userInfo", JSON.stringify(res));
    //       }
    //       resolve(res);
    //     });
    //   });
    // },
  },
};

export default app;
